import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BankAccount,
  PagedResultDto,
  CreateContractorBankAccount,
  UpdateContractorBankAccount,
  Payment,
  PaymentSearchDto
} from '@umss/shared/data-access';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private readonly apiUrl = '/api/Payments';

  constructor(private http: HttpClient) {}

  getAll(
    payload?: Partial<PaymentSearchDto>
  ): Observable<PagedResultDto<Payment>> {
    const params = HttpHelper.toHttpParams(payload ?? {});
    return this.http.get<PagedResultDto<Payment>>(`${this.apiUrl}`, { params });
  }

  get(id: string): Observable<Payment> {
    return this.http.get<Payment>(`${this.apiUrl}/${id}`);
  }

  // Bank accounts
  addBankAccount(
    account: CreateContractorBankAccount
  ): Observable<BankAccount> {
    return this.http.post<BankAccount>(
      `${this.apiUrl}/me/bank-accounts`,
      account
    );
  }

  getMyBankAccounts(): Observable<BankAccount[]> {
    return this.http.get<BankAccount[]>(`${this.apiUrl}/me/bank-accounts`);
  }

  getBankAccounts(contractorId: string): Observable<BankAccount[]> {
    return this.http.get<BankAccount[]>(
      `${this.apiUrl}/contractors/${contractorId}/bank-accounts`
    );
  }

  updateBankAccount(
    bankAccountId: string,
    payload: UpdateContractorBankAccount
  ): Observable<BankAccount> {
    return this.http.put<BankAccount>(
      `${this.apiUrl}/me/bank-accounts/${bankAccountId}`,
      payload
    );
  }

  verifyBankAccount(bankAccountId: string): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}/me/bank-accounts/${bankAccountId}/verify`,
      {}
    );
  }

  deleteBankAccount(bankAccountId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}/me/bank-accounts/${bankAccountId}`,
      {}
    );
  }

  setPrimaryBankAccount(
    bankAccountId: string
  ): Observable<{ message: string }> {
    return this.http.put<{ message: string }>(
      `${this.apiUrl}/me/bank-accounts/${bankAccountId}/primary`,
      {}
    );
  }
}
